! function (e) {
  function t(n) {
    if (i[n]) return i[n].exports;
    var r = i[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(r.exports, r, r.exports, t), r.l = !0, r.exports
  }
  var i = {};
  t.m = e, t.c = i, t.d = function (e, i, n) {
    t.o(e, i) || Object.defineProperty(e, i, {
      configurable: !1,
      enumerable: !0,
      get: n
    })
  }, t.n = function (e) {
    var i = e && e.__esModule ? function () {
      return e.default
    } : function () {
      return e
    };
    return t.d(i, "a", i), i
  }, t.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t)
  }, t.p = "", t(t.s = 22)
}([function (e, t) {
  function i(e, t) {
    var i;
    return n() ? (i = document.createEvent("CustomEvent"), i.initCustomEvent(e, !0, !0, {
      detail: t
    })) : i = new CustomEvent(e, {
      detail: t
    }), document.dispatchEvent(i)
  }

  function n() {
    return "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style
  }

  function r(e) {
    if (e) {
      var t = new XMLHttpRequest;
      t.open(e.type, e.url), t.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), t.withCredentials = !0, t.onload = function () {
        if ("function" == typeof e.always && e.always(), 200 === t.status && t.responseText) {
          var i = JSON.parse(t.responseText);
          return void(i.error ? 403 === i.error ? "function" == typeof e.fail && e.fail(i) : i.error && "function" == typeof e.fail && e.fail(i) : "function" == typeof e.done && e.done(i))
        }
      }, t.send(decodeURI(e.param))
    }
  }
  e.exports = {
    fireEvent: i,
    ie11: n,
    ajax: r
  }
}, function (e, t, i) {
  i(2), i(3), i(4);
  var n = i(5);
  document.addEventListener("DOMContentLoaded", function () {
    n.askUserToChooseAStore()
  })
}, function (e, t) {
  var i = document.getElementById("top-header-menu-trigger");
  i && i.addEventListener("change", function (e) {
    var t = document.querySelector(".site-top-header .icon-burger"),
      i = document.querySelector(".site-top-header");
    e.target.checked ? (i.classList.add("is-fixed"), t.classList.remove("is-collapsed")) : (i.classList.remove("is-fixed"), t.classList.add("is-collapsed"))
  });
  var n = document.querySelectorAll(".navbar__entry--pc");
  document.querySelector(".navbar__icon-btn div"), n && function () {

}()
}, function (e, t) {
  function i() {
    var e = this;
    this.$ul = document.querySelectorAll(".as-footer-ul"), this.$li = document.querySelectorAll(".as-footer-li"), this.$allShowLi = document.querySelectorAll(".as-footer-li-show"), this.$siblingShowLi = null, this.$state = document.querySelectorAll(".as-state"), this.index = null, this.showStatus = !1;
    for (var t = 0; t < this.$li.length; t++) ! function (t) {
      e.$li[t] && e.$li[t].addEventListener("click", function () {
        e.$siblingShowLi = e.$li[t].parentNode.querySelectorAll(".as-footer-li-show"), e.hidLiAndArrow(), (e.index != t || e.index == t && !e.showStatus) && e.showSiblingAndArrow(e.$li[t]), e.showStatus = e.index != t || !e.showStatus, e.index = t
      })
    }(t);
    this.$stateSibling = null, this.$stateI = null, this.stateStatus = !1;
    for (var i = 0; i < this.$state.length; i++) ! function (t) {
      e.$state[t] && e.$state[t].addEventListener("click", function () {
        e.$stateSibling = e.$state[t].parentNode.querySelector(".as-state-target"), e.$stateI = e.$state[t].querySelector(".as-state-i"), e.stateStatus ? (e.$stateSibling.classList.remove("flex"), e.$stateI.classList.remove("as-state-i-change")) : (e.$stateSibling.classList.add("flex"), e.$stateI.classList.add("as-state-i-change")), e.stateStatus = !e.stateStatus
      })
    }(i)
  }
  i.prototype = {
    constructor: i,
    hidLiAndArrow: function () {
      for (var e = 0; e < this.$allShowLi.length; e++) this.$allShowLi[e].classList.add("hidden");
      for (var e = 0; e < this.$li.length; e++) this.$li[e].querySelector("i").classList.add("footer-transform-90"), this.$li[e].querySelector("i").classList.remove("footer-transform-270")
    },
    showSiblingAndArrow: function (e) {
      for (var t = 0; t < this.$siblingShowLi.length; t++) this.$siblingShowLi[t].classList.remove("hidden");
      e.querySelector("i").classList.remove("footer-transform-90"), e.querySelector("i").classList.add("footer-transform-270")
    }
  }, new i
}, function (e, t) {
  function i() {
    var e = document.documentElement.scrollTop || document.body.scrollTop;
    document.body.scrollHeight, clearInterval(n), e > 0 && (n = setInterval(function () {
      var t = (0 - e) / 4;
      t = t > 0 ? Math.ceil(t) : Math.floor(t), e += t, document.documentElement.scrollTop = e, e <= 0 && clearInterval(n)
    }, 30))
  }
  var n = null,
    r = document.querySelector(".as-place-top");
  r && r.addEventListener("click", function (e) {
    i()
  })
}, function (e, t, i) {
  function n() {
    var e = document.querySelector('meta[name="googlefont"]');
    if (e) {
      var t = document.createElement("link");
      t.href = e.content, t.rel = "stylesheet", e.parentNode.insertBefore(t, e)
    }
  }

  function r() {
    "undefined" != typeof geoip2 && "/challenge" !== window.location.pathname && geoip2.country(function (e) {
      var t = d.get("chosenstore"),
        i = (document.querySelector(".as-current-stores").value.split(":")[0], document.querySelector(".as-current-stores").value.split(":")[1].split("$")),
        n = e.country.iso_code.toLowerCase();
      if (t || -1 !== i.indexOf(n)) {
        if (t)
          for (var r = document.querySelectorAll(".as-choose-store-ribbon a[data-stores]"), s = 0; s < r.length; s++) r[s].dataset.stores.split(":")[0] === t && 0 !== r[s].href.indexOf(window.location.origin) && (window.location = r[s].href)
      } else {
        var o = document.querySelector(".as-choose-store-ribbon");
        o && o.classList.remove("hidden")
      }
      for (var a = document.querySelectorAll(".as-ribbon-option"), s = 0; s < a.length; s++) a[s].addEventListener("click", function (e) {
        e.preventDefault();
        var t = e.currentTarget.dataset.stores.split(":")[0];
        d.set("chosenstore", t, {
          domain: ".redmagic.gg"
        }), 0 !== e.currentTarget.href.indexOf(window.location.origin) && (window.location = e.currentTarget.href)
      })
    })
  }

  function s() {
    for (var e = document.querySelectorAll("a[href]"), t = document.querySelectorAll("form[action]"), i = 0; i < e.length; i++) e[i].href = o(e[i].href);
    for (var i = 0; i < t.length; i++) t[i].action = o(t[i].action)
  }

  function o(e) {
    return e.replace("/?__current_page__", window.location.pathname + window.location.search).replace("?__current_page__", window.location.pathname + window.location.search).replace("__return_to_current_page__", "return_to=" + window.location.href)
  }

  function a() {
    for (var e, t = document.querySelectorAll(".as-sign-out-trigger"), i = 0; i < t.length; i++) e = t[i], e.onclick = function (e) {
      e = e || window.event, e.stopPropagation(), e.preventDefault();
      var t = e.currentTarget;
      return h.ajax({
        type: "POST",
        url: t.dataset && t.dataset.url,
        done: function (e) {
          window.location = t.href
        }
      }), !1
    }
  }

  function l() {
    for (var e, t = new f(document.getElementById("sign-up-modal")), i = document.querySelectorAll(".as-sign-up-trigger"), n = 0; n < i.length; n++) e = i[n], e.addEventListener("click", function (e) {
      e = e || window.event, e.preventDefault(), t.show()
    });
    new u
  }

  function c() {
    for (var e, t = new f(document.getElementById("sign-in-modal")), i = document.querySelectorAll(".as-sign-in-trigger"), n = 0; n < i.length; n++) e = i[n], e.addEventListener("click", function (e) {
      e = e || window.event, e.preventDefault(), t.show()
    });
    new m(document.getElementById("sign-in-form"), {
      done: function (e) {
        t.hide(), e.data.token && (window.location = window.location.origin + "/account/login/multipass/" + e.data.token)
      }
    })
  }
  var d = i(6),
    h = (i(7), i(0)),
    u = i(8),
    f = i(10),
    m = i(11);
  e.exports = {
    loadGoogleFont: n,
    askUserToChooseAStore: r,
    processUrls: s,
    initSignOut: a,
    initSignUp: l,
    initSignIn: c
  }
}, function (e, t, i) {
  var n, r;
  ! function (s) {
    if (n = s, void 0 !== (r = "function" == typeof n ? n.call(t, i, t, e) : n) && (e.exports = r), !0, e.exports = s(), !!0) {
      var o = window.Cookies,
        a = window.Cookies = s();
      a.noConflict = function () {
        return window.Cookies = o, a
      }
    }
  }(function () {
    function e() {
      for (var e = 0, t = {}; e < arguments.length; e++) {
        var i = arguments[e];
        for (var n in i) t[n] = i[n]
      }
      return t
    }

    function t(i) {
      function n(t, r, s) {
        var o;
        if ("undefined" != typeof document) {
          if (arguments.length > 1) {
            if (s = e({
                path: "/"
              }, n.defaults, s), "number" == typeof s.expires) {
              var a = new Date;
              a.setMilliseconds(a.getMilliseconds() + 864e5 * s.expires), s.expires = a
            }
            s.expires = s.expires ? s.expires.toUTCString() : "";
            try {
              o = JSON.stringify(r), /^[\{\[]/.test(o) && (r = o)
            } catch (e) {}
            r = i.write ? i.write(r, t) : encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)), t = t.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), t = t.replace(/[\(\)]/g, escape);
            var l = "";
            for (var c in s) s[c] && (l += "; " + c, !0 !== s[c] && (l += "=" + s[c]));
            return document.cookie = t + "=" + r + l
          }
          t || (o = {});
          for (var d = document.cookie ? document.cookie.split("; ") : [], h = /(%[0-9A-Z]{2})+/g, u = 0; u < d.length; u++) {
            var f = d[u].split("="),
              m = f.slice(1).join("=");
            this.json || '"' !== m.charAt(0) || (m = m.slice(1, -1));
            try {
              var p = f[0].replace(h, decodeURIComponent);
              if (m = i.read ? i.read(m, p) : i(m, p) || m.replace(h, decodeURIComponent), this.json) try {
                m = JSON.parse(m)
              } catch (e) {}
              if (t === p) {
                o = m;
                break
              }
              t || (o[p] = m)
            } catch (e) {}
          }
          return o
        }
      }
      return n.set = n, n.get = function (e) {
        return n.call(n, e)
      }, n.getJSON = function () {
        return n.apply({
          json: !0
        }, [].slice.call(arguments))
      }, n.defaults = {}, n.remove = function (t, i) {
        n(t, "", e(i, {
          expires: -1
        }))
      }, n.withConverter = t, n
    }
    return t(function () {})
  })
}, function (e, t) {
  function i(e) {
    if (e) {
      e = decodeURIComponent(e);
      var t = e.indexOf("?");
      if (-1 !== t) {
        var i = e.substr(t + 1),
          n = i.indexOf("?"),
          r = {};
        if (-1 === n)
          for (var s, o = i.split("&"), a = 0; a < o.length; a++) s = o[a].split("="), r[s[0]] = s[1];
        else
          for (var s, l = i.substr(n), o = i.substr(0, n).split("&"), a = 0; a < o.length; a++) s = o[a].split("="), a === o.length - 1 ? r[s[0]] = s[1] + l : r[s[0]] = s[1];
        return r
      }
    }
  }
  e.exports = {
    parse: i
  }
}, function (e, t, i) {
  function n(e) {
    if (this.$form = e || document.getElementById("sign-up-form"), this.$form) {
      this.$error = this.$form.querySelector(".as-form-error"), this.$tips = this.$form.querySelector(".as-form-tips");
      var t = this;
      this.$form.onsubmit = function (e) {
        e = e || window.event;
        var i = r(t.$form),
          n = new XMLHttpRequest;
        return n.open("POST", t.$form.action), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), n.withCredentials = !0, n.onload = function () {
          if (200 === n.status && n.responseText) {
            var e = JSON.parse(n.responseText);
            return 403 === e.error ? void t.showFormError(e.message) : e.error ? void t.showFormError(e.message) : (window.location = window.location.origin + "/account/login/multipass/" + e.data.token, void s("customer-registration-done"))
          }
        }, n.send(decodeURI(i)), !1
      }
    }
  }
  var r = i(9),
    s = i(0).fireEvent;
  n.prototype = {
    constructor: n,
    showFormError: function (e) {
      this.$error && e && (this.$error.innerText = e), this.$error && this.$error.classList.remove("hidden")
    }
  }, e.exports = n
}, function (e, t) {
  function i(e) {
    if (e && "FORM" === e.nodeName) {
      var t, i, n = [];
      for (t = e.elements.length - 1; t >= 0; t -= 1)
        if ("" !== e.elements[t].name) switch (e.elements[t].nodeName) {
        case "INPUT":
          switch (e.elements[t].type) {
          case "text":
          case "email":
          case "hidden":
          case "password":
          case "button":
          case "reset":
          case "submit":
            n.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value));
            break;
          case "checkbox":
          case "radio":
            e.elements[t].checked && n.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value))
          }
          break;
        case "TEXTAREA":
          n.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value));
          break;
        case "SELECT":
          switch (e.elements[t].type) {
          case "select-one":
            n.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value));
            break;
          case "select-multiple":
            for (i = e.elements[t].options.length - 1; i >= 0; i -= 1) e.elements[t].options[i].selected && n.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].options[i].value))
          }
          break;
        case "BUTTON":
          switch (e.elements[t].type) {
          case "reset":
          case "submit":
          case "button":
            n.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value))
          }
        }
      return n.join("&")
    }
  }
  e.exports = i
}, function (e, t) {
  function i(e) {
    if (e) {
      this.$node = e, this.$close = this.$node.querySelector(".as-close"), this.$bg = this.$node.querySelector(".modal-background");
      var t = this;
      this.$close.onclick = function () {
        t.hide()
      }, this.$bg.onclick = function () {
        t.hide()
      }
    }
  }
  i.prototype = {
    constructor: i,
    hide: function () {
      this.$node.classList.remove("is-active")
    },
    show: function () {
      this.$node.classList.add("is-active")
    }
  }, e.exports = i
}, function (e, t) {
  function i(e, t) {
    e && (this.$form = e, this.options = t || {}, this.$submit = this.$form.querySelector(".as-submit"), this.$error = this.$form.querySelector(".as-form-error"), this.$tips = this.$form.querySelector(".as-form-tips"), this.init())
  }
  i.prototype = {
    constructor: i,
    init: function () {
      var e = this;
      "function" == typeof this.options.init && this.options.init.call(this), this.$form.onsubmit = function (t) {
        return t = t || window.event, t.preventDefault(), t.stopPropagation(), !(!e.validate() || "function" == typeof e.options.validate && !e.options.validate.call(e) || (e.freeze(), 1))
      }, this.$form.addEventListener("input", function () {
        e.clearErrorMessage()
      })
    },
    fields: function () {
      for (var e = Array.prototype.concat(Array.prototype.slice.call(this.$form.querySelectorAll("input")), Array.prototype.slice.call(this.$form.querySelectorAll("textarea"))), t = {}, i = 0; i < e.length; i++) {
        var n = e[i];
        if (n.name) {
          for (var r, s, o = n.parentNode.parentNode.children, a = 0; a < o.length; a++) {
            var l = o[a];
            l.classList.contains("as-field-tips") && (r = l), l.classList.contains("as-field-error") && (s = l)
          }
          t[n.name] = {
            regx: n.dataset && new RegExp(n.dataset.regx),
            $node: n,
            required: !!n.required,
            value: n.value,
            $tips: r,
            $error: s
          }
        }
      }
      return t
    },
    validate: function () {
      var e = !0,
        t = this.fields();
      for (var i in t) {
        var n = t[i];
        (n.required && !n.value || n.regx && !n.regx.test(n.value)) && (n.$node.classList.add("invalid"), n.$error && n.$error.classList.remove("hidden"), e = !1)
      }
      return e
    },
    freeze: function () {
      var e = this,
        t = this.fields();
      for (var i in t) t[i].$node.disabled = !0;
      this.$submit.disabled = !0, this.$submit.classList.add("debuzz"), setTimeout(function () {
        e.unfreeze()
      }, 3e3)
    },
    unfreeze: function () {
      var e = this.fields();
      for (var t in e) e[t].$node.disabled = !1;
      this.$submit.disabled = !1, this.$submit.classList.remove("debuzz")
    },
    showFormError: function (e) {
      this.$error && e && (this.$error.innerText = e), this.$error && this.$error.classList.remove("hidden")
    },
    clearErrorMessage: function () {
      this.$error && this.$error.classList.add("hidden");
      var e = this.fields();
      for (var t in e) {
        var i = e[t];
        i.$error && i.$error.classList.add("hidden"), i.$node.classList.remove("invalid")
      }
    },
    showFormTips: function (e) {
      this.$tips && e && (this.$tips.innerText = e), this.$tips && this.$tips.classList.remove("hidden")
    }
  }, e.exports = i
}, function (e, t) {
  var i = document.querySelectorAll(".as-link-group");
  if (i)
    for (var n = 0; n < i.length; n++) ! function (e) {
      var t = e.querySelector(".as-trigger"),
        i = e.querySelectorAll(".as-links a"),
        n = e.querySelector(".as-backdrop-curtain"),
        r = e.querySelector(".as-links a.selected");
      if (r && (t.querySelector(".as-selected-text").textContent = r.textContent), t && t.addEventListener("click", function (t) {
          e.classList.contains("option-visible") ? e.classList.remove("option-visible") : e.classList.add("option-visible")
        }), i)
        for (var s = 0; s < i.length; s++) ! function (i) {
          i.addEventListener("click", function (i) {
            var n = t.querySelector(".as-selected-text");
            e.classList.remove("option-visible"), r = e.querySelector(".as-links a.selected"), r && r.classList.remove("selected"), i.target.classList.add("selected"), n && (n.textContent = i.target.textContent)
          })
        }(i[s]);
      n && n.addEventListener("click", function (t) {
        e.classList.remove("option-visible")
      })
    }(i[n])
}, function (e, t, i) {
  function n(e, t) {
    if (e && (this.$slides = e.querySelector(".as-carousel-slides"), this.$slides)) {
      this.$page = this.$slides.getAttribute("data-page") || 1, this.$prev = e.querySelector(".as-carousel-prev"), this.$next = e.querySelector(".as-carousel-next"), this.$dots = e.querySelectorAll(".as-carousel-dot");
      var i = this;
      this.siema = new s(Object.assign({
        selector: this.$slides,
        loop: !0,
        perPage: Number(i.$page),
        onChange: function () {
          var t = e.querySelector(".as-carousel-dot.is-active");
          t && t.classList.remove("is-active"), i.$dots.length && i.$dots[this.currentSlide + (this.currentSlide < 0 ? i.$dots.length : 0)].classList.add("is-active")
        }
      }, r(e.dataset), t)), this.$prev && this.$prev.addEventListener("click", function () {
        i.siema.prev()
      }), this.$next && this.$next.addEventListener("click", function () {
        i.siema.next()
      }), $activeDot = e.querySelector(".as-carousel-dot.is-active"), !$activeDot && this.$dots.length && this.$dots[0].classList.add("is-active");
      for (var n, o = 0; o < this.$dots.length; o++) n = this.$dots[o],
        function (e) {
          n.addEventListener("click", i.sync)
        }()
    }
  }

  function r(e) {
    var t = {};
    for (var i in e) {
      var n = e[i];
      "true" !== n ? "false" !== n ? isNaN(n) ? t[i] = n : t[i] = n - 0 : t[i] = !1 : t[i] = !0
    }
    return t
  }
  var s = i(14);
  n.prototype = {
    constructor: n,
    destroy: function (e, t) {
      var i = this;
      this.destroy(e, function () {
        i.$prev && i.removeEventListener("click", i.prev), i.$next && i.removeEventListener("click", i.next);
        for (var e, n = 0; n < i.$dots.length; n++) e = i.$dots[n],
          function (t) {
            e.removeEventListener("click", i.sync)
          }();
        "function" == typeof t && t()
      })
    }
  }, Array.prototype.forEach.call(document.querySelectorAll(".as-carousel"), function (e) {
    new n(e)
  }), e.exports = n
}, function (e, t, i) {
  ! function (t, i) {
    e.exports = function () {
      return function (e) {
        function t(n) {
          if (i[n]) return i[n].exports;
          var r = i[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return e[n].call(r.exports, r, r.exports, t), r.l = !0, r.exports
        }
        var i = {};
        return t.m = e, t.c = i, t.d = function (e, i, n) {
          t.o(e, i) || Object.defineProperty(e, i, {
            configurable: !1,
            enumerable: !0,
            get: n
          })
        }, t.n = function (e) {
          var i = e && e.__esModule ? function () {
            return e.default
          } : function () {
            return e
          };
          return t.d(i, "a", i), i
        }, t.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t)
        }, t.p = "", t(t.s = 0)
      }([function (e, t, i) {
        "use strict";

        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
          },
          s = function () {
            function e(e, t) {
              for (var i = 0; i < t.length; i++) {
                var n = t[i];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
              }
            }
            return function (t, i, n) {
              return i && e(t.prototype, i), n && e(t, n), t
            }
          }(),
          o = function () {
            function e(t) {
              var i = this;
              if (n(this, e), this.config = e.mergeSettings(t), this.selector = "string" == typeof this.config.selector ? document.querySelector(this.config.selector) : this.config.selector, null === this.selector) throw new Error("Something wrong with your selector 亊");
              this.resolveSlidesNumber(), this.selectorWidth = this.selector.offsetWidth, this.innerElements = [].slice.call(this.selector.children), this.currentSlide = this.config.loop ? this.config.startIndex % this.innerElements.length : Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage)), this.transformProperty = e.webkitOrNot(), ["resizeHandler", "touchstartHandler", "touchendHandler", "touchmoveHandler", "mousedownHandler", "mouseupHandler", "mouseleaveHandler", "mousemoveHandler", "clickHandler"].forEach(function (e) {
                i[e] = i[e].bind(i)
              }), this.init()
            }
            return s(e, [{
              key: "attachEvents",
              value: function () {
                window.addEventListener("resize", this.resizeHandler), this.config.draggable && (this.pointerDown = !1, this.drag = {
                  startX: 0,
                  endX: 0,
                  startY: 0,
                  letItGo: null,
                  preventClick: !1
                }, this.selector.addEventListener("touchstart", this.touchstartHandler), this.selector.addEventListener("touchend", this.touchendHandler), this.selector.addEventListener("touchmove", this.touchmoveHandler), this.selector.addEventListener("mousedown", this.mousedownHandler), this.selector.addEventListener("mouseup", this.mouseupHandler), this.selector.addEventListener("mouseleave", this.mouseleaveHandler), this.selector.addEventListener("mousemove", this.mousemoveHandler), this.selector.addEventListener("click", this.clickHandler))
              }
            }, {
              key: "detachEvents",
              value: function () {
                window.removeEventListener("resize", this.resizeHandler), this.selector.removeEventListener("touchstart", this.touchstartHandler), this.selector.removeEventListener("touchend", this.touchendHandler), this.selector.removeEventListener("touchmove", this.touchmoveHandler), this.selector.removeEventListener("mousedown", this.mousedownHandler), this.selector.removeEventListener("mouseup", this.mouseupHandler), this.selector.removeEventListener("mouseleave", this.mouseleaveHandler), this.selector.removeEventListener("mousemove", this.mousemoveHandler), this.selector.removeEventListener("click", this.clickHandler)
              }
            }, {
              key: "init",
              value: function () {
                this.attachEvents(), this.selector.style.overflow = "hidden", this.selector.style.direction = this.config.rtl ? "rtl" : "ltr", this.buildSliderFrame(), this.config.onInit.call(this)
              }
            }, {
              key: "buildSliderFrame",
              value: function () {
                var e = this.selectorWidth / this.perPage,
                  t = this.config.loop ? this.innerElements.length + 2 * this.perPage : this.innerElements.length;
                this.sliderFrame = document.createElement("div"), this.sliderFrame.style.width = e * t + "px", this.enableTransition(), this.config.draggable && (this.selector.style.cursor = "-webkit-grab");
                var i = document.createDocumentFragment();
                if (this.config.loop)
                  for (var n = this.innerElements.length - this.perPage; n < this.innerElements.length; n++) {
                    var r = this.buildSliderFrameItem(this.innerElements[n].cloneNode(!0));
                    i.appendChild(r)
                  }
                for (var s = 0; s < this.innerElements.length; s++) {
                  var o = this.buildSliderFrameItem(this.innerElements[s]);
                  i.appendChild(o)
                }
                if (this.config.loop)
                  for (var a = 0; a < this.perPage; a++) {
                    var l = this.buildSliderFrameItem(this.innerElements[a].cloneNode(!0));
                    i.appendChild(l)
                  }
                this.sliderFrame.appendChild(i), this.selector.innerHTML = "", this.selector.appendChild(this.sliderFrame), this.slideToCurrent()
              }
            }, {
              key: "buildSliderFrameItem",
              value: function (e) {
                var t = document.createElement("div");
                return t.style.cssFloat = this.config.rtl ? "right" : "left", t.style.float = this.config.rtl ? "right" : "left", t.style.width = (this.config.loop ? 100 / (this.innerElements.length + 2 * this.perPage) : 100 / this.innerElements.length) + "%", t.appendChild(e), t
              }
            }, {
              key: "resolveSlidesNumber",
              value: function () {
                if ("number" == typeof this.config.perPage) this.perPage = this.config.perPage;
                else if ("object" === r(this.config.perPage)) {
                  this.perPage = 1;
                  for (var e in this.config.perPage) window.innerWidth >= e && (this.perPage = this.config.perPage[e])
                }
              }
            }, {
              key: "prev",
              value: function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                  t = arguments[1];
                if (!(this.innerElements.length <= this.perPage)) {
                  var i = this.currentSlide;
                  if (this.config.loop)
                    if (this.currentSlide - e < 0) {
                      this.disableTransition();
                      var n = this.currentSlide + this.innerElements.length,
                        r = this.perPage,
                        s = n + r,
                        o = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage),
                        a = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
                      this.sliderFrame.style[this.transformProperty] = "translate3d(" + (o + a) + "px, 0, 0)", this.currentSlide = n - e
                    } else this.currentSlide = this.currentSlide - e;
                  else this.currentSlide = Math.max(this.currentSlide - e, 0);
                  i !== this.currentSlide && (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), t && t.call(this))
                }
              }
            }, {
              key: "next",
              value: function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                  t = arguments[1];
                if (!(this.innerElements.length <= this.perPage)) {
                  var i = this.currentSlide;
                  if (this.config.loop)
                    if (this.currentSlide + e > this.innerElements.length - this.perPage) {
                      this.disableTransition();
                      var n = this.currentSlide - this.innerElements.length,
                        r = this.perPage,
                        s = n + r,
                        o = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage),
                        a = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
                      this.sliderFrame.style[this.transformProperty] = "translate3d(" + (o + a) + "px, 0, 0)", this.currentSlide = n + e
                    } else this.currentSlide = this.currentSlide + e;
                  else this.currentSlide = Math.min(this.currentSlide + e, this.innerElements.length - this.perPage);
                  i !== this.currentSlide && (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), t && t.call(this))
                }
              }
            }, {
              key: "disableTransition",
              value: function () {
                this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing, this.sliderFrame.style.transition = "all 0ms " + this.config.easing
              }
            }, {
              key: "enableTransition",
              value: function () {
                this.sliderFrame.style.webkitTransition = "all " + this.config.duration + "ms " + this.config.easing, this.sliderFrame.style.transition = "all " + this.config.duration + "ms " + this.config.easing
              }
            }, {
              key: "goTo",
              value: function (e, t) {
                if (!(this.innerElements.length <= this.perPage)) {
                  var i = this.currentSlide;
                  this.currentSlide = this.config.loop ? e % this.innerElements.length : Math.min(Math.max(e, 0), this.innerElements.length - this.perPage), i !== this.currentSlide && (this.slideToCurrent(), this.config.onChange.call(this), t && t.call(this))
                }
              }
            }, {
              key: "slideToCurrent",
              value: function (e) {
                var t = this,
                  i = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide,
                  n = (this.config.rtl ? 1 : -1) * i * (this.selectorWidth / this.perPage);
                e ? requestAnimationFrame(function () {
                  requestAnimationFrame(function () {
                    t.enableTransition(), t.sliderFrame.style[t.transformProperty] = "translate3d(" + n + "px, 0, 0)"
                  })
                }) : this.sliderFrame.style[this.transformProperty] = "translate3d(" + n + "px, 0, 0)"
              }
            }, {
              key: "updateAfterDrag",
              value: function () {
                var e = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX),
                  t = Math.abs(e),
                  i = this.config.multipleDrag ? Math.ceil(t / (this.selectorWidth / this.perPage)) : 1,
                  n = e > 0 && this.currentSlide - i < 0,
                  r = e < 0 && this.currentSlide + i > this.innerElements.length - this.perPage;
                e > 0 && t > this.config.threshold && this.innerElements.length > this.perPage ? this.prev(i) : e < 0 && t > this.config.threshold && this.innerElements.length > this.perPage && this.next(i), this.slideToCurrent(n || r)
              }
            }, {
              key: "resizeHandler",
              value: function () {
                this.resolveSlidesNumber(), this.currentSlide + this.perPage > this.innerElements.length && (this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage), this.selectorWidth = this.selector.offsetWidth, this.buildSliderFrame()
              }
            }, {
              key: "clearDrag",
              value: function () {
                this.drag = {
                  startX: 0,
                  endX: 0,
                  startY: 0,
                  letItGo: null,
                  preventClick: this.drag.preventClick
                }
              }
            }, {
              key: "touchstartHandler",
              value: function (e) {
                -1 !== ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(e.target.nodeName) || (e.stopPropagation(), this.pointerDown = !0, this.drag.startX = e.touches[0].pageX, this.drag.startY = e.touches[0].pageY)
              }
            }, {
              key: "touchendHandler",
              value: function (e) {
                e.stopPropagation(), this.pointerDown = !1, this.enableTransition(), this.drag.endX && this.updateAfterDrag(), this.clearDrag()
              }
            }, {
              key: "touchmoveHandler",
              value: function (e) {
                if (e.stopPropagation(), null === this.drag.letItGo && (this.drag.letItGo = Math.abs(this.drag.startY - e.touches[0].pageY) < Math.abs(this.drag.startX - e.touches[0].pageX)), this.pointerDown && this.drag.letItGo) {
                  e.preventDefault(), this.drag.endX = e.touches[0].pageX, this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing, this.sliderFrame.style.transition = "all 0ms " + this.config.easing;
                  var t = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide,
                    i = t * (this.selectorWidth / this.perPage),
                    n = this.drag.endX - this.drag.startX,
                    r = this.config.rtl ? i + n : i - n;
                  this.sliderFrame.style[this.transformProperty] = "translate3d(" + (this.config.rtl ? 1 : -1) * r + "px, 0, 0)"
                }
              }
            }, {
              key: "mousedownHandler",
              value: function (e) {
                -1 !== ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(e.target.nodeName) || (e.preventDefault(), e.stopPropagation(), this.pointerDown = !0, this.drag.startX = e.pageX)
              }
            }, {
              key: "mouseupHandler",
              value: function (e) {
                e.stopPropagation(), this.pointerDown = !1, this.selector.style.cursor = "-webkit-grab", this.enableTransition(), this.drag.endX && this.updateAfterDrag(), this.clearDrag()
              }
            }, {
              key: "mousemoveHandler",
              value: function (e) {
                if (e.preventDefault(), this.pointerDown) {
                  "A" === e.target.nodeName && (this.drag.preventClick = !0), this.drag.endX = e.pageX, this.selector.style.cursor = "-webkit-grabbing", this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing, this.sliderFrame.style.transition = "all 0ms " + this.config.easing;
                  var t = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide,
                    i = t * (this.selectorWidth / this.perPage),
                    n = this.drag.endX - this.drag.startX,
                    r = this.config.rtl ? i + n : i - n;
                  this.sliderFrame.style[this.transformProperty] = "translate3d(" + (this.config.rtl ? 1 : -1) * r + "px, 0, 0)"
                }
              }
            }, {
              key: "mouseleaveHandler",
              value: function (e) {
                this.pointerDown && (this.pointerDown = !1, this.selector.style.cursor = "-webkit-grab", this.drag.endX = e.pageX, this.drag.preventClick = !1, this.enableTransition(), this.updateAfterDrag(), this.clearDrag())
              }
            }, {
              key: "clickHandler",
              value: function (e) {
                this.drag.preventClick && e.preventDefault(), this.drag.preventClick = !1
              }
            }, {
              key: "remove",
              value: function (e, t) {
                if (e < 0 || e >= this.innerElements.length) throw new Error("Item to remove doesn't exist 亊");
                var i = e < this.currentSlide,
                  n = this.currentSlide + this.perPage - 1 === e;
                (i || n) && this.currentSlide--, this.innerElements.splice(e, 1), this.buildSliderFrame(), t && t.call(this)
              }
            }, {
              key: "insert",
              value: function (e, t, i) {
                if (t < 0 || t > this.innerElements.length + 1) throw new Error("Unable to inset it at this index 亊");
                if (-1 !== this.innerElements.indexOf(e)) throw new Error("The same item in a carousel? Really? Nope 亊");
                var n = t <= this.currentSlide > 0 && this.innerElements.length;
                this.currentSlide = n ? this.currentSlide + 1 : this.currentSlide, this.innerElements.splice(t, 0, e), this.buildSliderFrame(), i && i.call(this)
              }
            }, {
              key: "prepend",
              value: function (e, t) {
                this.insert(e, 0), t && t.call(this)
              }
            }, {
              key: "append",
              value: function (e, t) {
                this.insert(e, this.innerElements.length + 1), t && t.call(this)
              }
            }, {
              key: "destroy",
              value: function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                  t = arguments[1];
                if (this.detachEvents(), this.selector.style.cursor = "auto", e) {
                  for (var i = document.createDocumentFragment(), n = 0; n < this.innerElements.length; n++) i.appendChild(this.innerElements[n]);
                  this.selector.innerHTML = "", this.selector.appendChild(i), this.selector.removeAttribute("style")
                }
                t && t.call(this)
              }
            }], [{
              key: "mergeSettings",
              value: function (e) {
                var t = {
                    selector: ".siema",
                    duration: 200,
                    easing: "ease-out",
                    perPage: 1,
                    startIndex: 0,
                    draggable: !0,
                    multipleDrag: !0,
                    threshold: 20,
                    loop: !1,
                    rtl: !1,
                    onInit: function () {},
                    onChange: function () {}
                  },
                  i = e;
                for (var n in i) t[n] = i[n];
                return t
              }
            }, {
              key: "webkitOrNot",
              value: function () {
                return "string" == typeof document.documentElement.style.transform ? "transform" : "WebkitTransform"
              }
            }]), e
          }();
        t.default = o, e.exports = t.default
      }])
    }()
  }("undefined" != typeof self && self)
}, , , , , , , , function (e, t, i) {
  function n() {
    var e = this;
    this.status = !1, this.$drop = document.querySelector(".as-dropdown"), this.$dropIco = document.querySelector(".as-dropdown-ico"), this.$dropBox = document.querySelector(".as-dropdown-box"), this.$dropLink = document.querySelectorAll(".as-dropdown-target"), this.$surface = document.querySelector(".as-surface"), this.$drop && this.$drop.addEventListener("click", function () {
      e.status ? (e.$dropBox.classList.add("hidden"), e.$dropIco.classList.add("down"), e.$dropIco.classList.remove("up"), e.$surface.classList.add("hidden")) : (e.$dropBox.classList.remove("hidden"), e.$dropIco.classList.add("up"), e.$dropIco.classList.remove("down"), e.$surface.classList.remove("hidden")), e.status = !e.status
    })
  }
  i(23), i(1), i(13), i(12), new n
}, function (e, t) {}]);
